import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { environment } from '../environments/environment';


const authToken = JSON.parse(localStorage.getItem('user_token'));
const http_options = {
	headers: new HttpHeaders({
		'Content-Type': 'application/json',
		'Authorization': `${authToken}`
	})
};

class RRForm {
	rr_number:string;
	sto_number:string;
	shortage : string;
	rr_weigth: string;
	rr_date: string;
	consignor: string;
	product: string;
	loading: string;
	station: string;
}

class dashboardStat{
	"rr_number" : string;
	"is_acknowledged": any;
	"is_acknowledged_weight": any;
	"not_acknowledged" : any; 
	"not_acknowledged_weight" : any; 
	"product" : string; 
	"total_weight" : any;
	 
}

@Injectable()
export class RRFormService {

private url = environment.url;

	constructor(private http: HttpClient) { }
	getAllRRForm(): Observable<RRForm[]>{
		return this.http.get<RRForm[]>(this.url + '/rrform/all', http_options);
	};
	getAllPendingRR(): Observable<dashboardStat[]>{
		return this.http.get<dashboardStat[]>(this.url + '/dashboard/stats', http_options);
	};
	getRRFormWith(id:string): Observable<RRForm[]> {
		console.log (this.http.get<RRForm[]>(this.url + '/rrform/get/' + id, http_options));
		return this.http.get<RRForm[]>(this.url + '/rrform/get/' + id, http_options);
	}
	getLastRRNumber(id:string): Observable<RRForm[]> {
		console.log (this.http.get<RRForm[]>(this.url + '/rrform/getlastrrnumber/' + id, http_options));
		return this.http.get<RRForm[]>(this.url + '/rrform/getlastrrnumber/' + id, http_options);
	}
	getRRFormWithBranch(branch:string): Observable<RRForm[]> {
		return this.http.get<RRForm[]>(this.url + '/rrform/getrrnumberwithbranch/' + branch, http_options);
	}
	addNewRR(form): Observable<string>{
		return this.http.post<string>(this.url + '/rrform/submit', form, http_options);
	}
}



// WEBPACK FOOTER //
// /Users/meghneel/work/baba_frontend/src/app/r-r-form.service.ts